import React from 'react'

// reactstrap components
import { Button, Container, Row, Col } from 'reactstrap'

import logoMural from 'assets/img/logo_mural_2.png'

function Politicas() {
  document.documentElement.classList.remove('nav-open')
  React.useEffect(() => {
    document.body.classList.add('termos-de-uso')
    return function cleanup() {
      document.body.classList.remove('termos-de-uso')
    }
  })

  function goBack() {
    window.history.go(-1)
  }

  return (
    <>
      <div className="section">
        <Container className="text-center">
          <Row>
            <Col style={{ textAlign: 'end' }}>
              <Button onClick={goBack} className="btn-round" color="#000">
                <span>X</span>
              </Button>
            </Col>
          </Row>
          <Row>
            <Col>
              <img src={logoMural} style={{ width: 260 }} alt="" />
            </Col>
          </Row>
          <Row>
            <Col className="ml-auto mr-auto text-left" md="12">
              <div style={{ textAlign: 'center' }}>
                <h2 className="title" style={{ fontWeight: 600, letterSpacing: 2, marginTop: 50 }}>
                  Política de Privacidade
                </h2>
              </div>

              <div>
                <p style={{ fontWeight: 400 }}>
                  <span style={{ fontWeight: 600 }}>1. Nosso Compromisso com sua Privacidade</span>
                  <br /> <br />A EVOLUCIONAL EDITORA E SERVIÇOS DE INFORMAÇÃO E INTERNET, CNPJ 23.447896/0001-57,
                  endereço Rua Embiruçu 185 – Loteamento Alphaville - Campinas – SP – 13.098-320, telefone +55 19
                  3756-1640 está comprometida em proteger a privacidade de seus clientes. A política de privacidade da
                  EVOLUCIONAL (a “Política de Privacidade”) se aplica a todas as informações pessoais coletadas por nós
                  ou submetidas a nós, seja off-line ou on-line, incluindo informações pessoais coletadas ou submetidas
                  através de nossos websites (nossos “Websites”) e quaisquer sites de dispositivos móveis, aplicativos e
                  widgets, e outros recursos interativos de dispositivos móveis, (coletivamente, nossos “Apps”), através
                  das nossas páginas oficiais em mídias sociais que controlamos (nossas “Páginas de Mídia Social”) bem
                  como através de mensagens de e-mail em formato HTML que enviamos a você (coletivamente, incluindo as
                  Páginas de Mídia Social, Apps, e Websites, os “Sites”). Ao clicar na caixa apropriada, usar os
                  Websites ou nos fornecer Informações Pessoais, você reconhece e confirma que você leu, compreendeu e
                  que você concorda com os termos e condições desta Política de Privacidade. Portanto, você concorda com
                  a coleta, uso, processamento, transferência e divulgação de suas informações pessoais, conforme
                  descrito nesta Política de Privacidade.
                </p>
                <br />

                <p style={{ fontWeight: 400 }}>
                  <span style={{ fontWeight: 600 }}>2. Informações Pessoais</span>
                  <br />
                  <br />
                  <span style={{ fontWeight: 600 }}>Quais informações pessoais nós coletamos?</span>
                  <br />
                  “Informações Pessoais” são informações que identificam você como um indivíduo, tais como:
                  <br />
                  <br />
                  ● Nome
                  <br />
                  ● Nome de usuário
                  <br />
                  ● Endereço postal (incluindo endereços de cobrança e de entrega)
                  <br />
                  ● Número de telefone (incluindo números de telefone de casa residencial e de celular móvel)
                  <br />
                  ● Endereço de e-mail
                  <br />
                  ● País de residência
                  <br />
                  ● Endereço de IP
                  <br />
                  ● Registros de acesso (incluindo data e horário de acesso associado com seu Endereço de IP)
                  <br />
                  ● Nome e endereço da escola
                  <br />
                  ● Nome e endereço da empresa
                  <br />
                  ● Informações do navegador e do dispositivo
                  <br />
                  ● Informações dos arquivos de log de servidor
                  <br />
                  ● Informações coletadas através de cookies, pixel tags e outras tecnologias
                  <br />
                  ● Dados de utilização de App
                  <br />
                  ● Informações demográficas e outras informações fornecidas por você
                  <br />
                  ● Informações de localização
                  <br />
                  ● Informações agregadas
                  <br />
                  <br />
                  <span style={{ fontWeight: 600 }}>Como nós coletamos informações pessoais?</span>
                  <br />
                  Nós podemos coletar Informações Pessoais de diversas maneiras, incluindo:
                  <br />
                  <br />
                  ● Através dos Sites: Podemos coletar Informações Pessoais por meio dos Sites, por exemplo, quando você
                  se cadastra para receber um serviço, fazer download de um conteúdo ou demonstrar interesse em saber
                  mais sobre produtos e serviços por meio de um contato.
                  <br />
                  <br />
                  ● Off-line: Podemos coletar suas Informações Pessoais off-line, por exemplo, quando você entra em
                  contato com o serviço de atendimento ao cliente.
                  <br />
                  <br />
                  ● De Outras Fontes: Podemos receber suas Informações Pessoais de outras fontes, tais como bancos de
                  dados públicos; parceiros de marketing conjuntos; plataformas de mídia social; de pessoas com as quais
                  você tenha amizade ou às quais você esteja de outra forma conectado em plataformas de mídia social,
                  bem como de outros terceiros. Por exemplo, se você escolher conectar sua conta de mídia social à sua
                  conta do Website, determinadas Informações Pessoais de sua conta de mídia social serão compartilhadas
                  conosco, que podem incluir Informações Pessoais que sejam parte de seu perfil ou dos perfis de seus
                  amigos.
                  <br />
                  <br />
                  ● Através do seu navegador ou dispositivo: Determinadas informações são coletadas pela maioria dos
                  navegadores ou automaticamente através de seu dispositivo. Nós usamos essas informações para fins
                  estatísticos e, também, para garantir que os Sites funcionem adequadamente.
                  <br />
                  <br />
                  ● Através de arquivos de log de servidor: Seu “Endereço de IP” é um número que é automaticamente
                  atribuído ao computador ou dispositivo que você está usando pelo seu Provedor de Serviço de Internet
                  (em inglês, ISP). Um Endereço de IP é identificado e registrado automaticamente em nossos arquivos de
                  log de servidor sempre que um usuário visita os Sites, juntamente com o horário da visita e a(s)
                  página(s) que foram visitadas.
                  <br />
                  <br />
                  ● Usando cookies: Cookies permitem que um servidor de internet transfira dados a um computador ou
                  dispositivo para manutenção de registro e outros propósitos. Caso você não queira que informações
                  sejam coletadas por meio do uso de cookies, há um procedimento simples na maioria dos navegadores que
                  permite que você desative o uso de cookies. Para informações detalhadas sobre os cookies que
                  utilizamos e as finalidades para as quais os utilizamos, por favor, veja o item 3.
                  <br />
                  <br />
                  ● Através do uso de um App: Quando você faz o download e utiliza um App, nós e nossos prestadores de
                  serviços podemos monitorar e coletar dados de utilização do App, tais como a data e horário em que o
                  App acessa os no
                  <br />
                  <br />
                  ● De você: Informações como data de nascimento, gênero e código postal, assim como outras informações,
                  como seus meios de comunicação preferidos, podem ser coletadas quando você as fornecer
                  voluntariamente.
                  <br />
                  <br />
                  ● Localização Física: Podemos coletar a localização física do seu dispositivo.
                  <br />
                  <br />
                  <span style={{ fontWeight: 600 }}>Como utilizamos Informações Pessoais?</span> <br />
                  Podemos utilizar Informações Pessoais:
                  <br />
                  <br />
                  ● Para responder às suas solicitações e atender seus pedidos, como para lhe enviar newsletters,
                  convites, conteúdos, informações sobre nossos produtos e serviços ou para responder às suas perguntas
                  e comentários.
                  <br />
                  <br />
                  ● Para lhe enviar informações administrativas, por exemplo, informações referentes aos Sites e
                  alterações aos nossos termos, condições e políticas. Tendo em vista que essas informações podem ser
                  importantes para a sua utilização dos Sites, você não poderá optar por não receber tais comunicações
                  (opt-out).
                  <br />
                  <br />
                  ● Para lhe fornecer atualizações e anúncios referentes aos nossos produtos, serviços, promoções e
                  programas e para lhe enviar convites para participar de programas e eventos especiais.
                  <br />
                  <br />
                  ● Para permitir que você entre em contato e seja contatado pela equipe comercial.
                  <br />
                  <br />
                  ● Para permitir que você participe em listas de discussão, bate-papo, páginas de perfil e blogs e
                  outros serviços nos quais você possa postar informações e materiais (incluindo nossas Páginas de Mídia
                  Social).
                  <br />
                  <br />
                  ● Para nossas finalidades comerciais, tais como análise e gestão de nossos negócios, pesquisa de
                  mercado, auditorias, desenvolvimento de novos produtos, aprimoramentos dos nossos Sites, melhorias de
                  nossos serviços e produtos, identificação de tendências de uso, avaliação da eficácia de nossas
                  campanhas promocionais, personalização da experiência e conteúdo dos Sites com base em suas atividades
                  anteriores nos Sites, e medição de satisfação de clientes e fornecimento de serviços de atendimento ao
                  cliente (incluindo solução de problemas relacionados a problemas dos clientes).
                  <br />
                  <br />
                  ● Utilizamos informações coletadas por navegadores ou seu dispositivo para fins estatísticos e,
                  também, para garantir que os Sites funcionem adequadamente.
                  <br />
                  <br />
                  ● Para informações detalhadas sobre os cookies que utilizamos e as finalidades para as quais os
                  utilizamos, por favor, veja o item 3.
                  <br />
                  <br />
                  ● Nós podemos utilizar a localização física do seu dispositivo para lhe fornecer conteúdo e serviços
                  personalizados baseados na localização. Podemos, também, compartilhar a localização física do seu
                  dispositivo, juntamente com informações de quais anúncios publicitários você viu e outras informações
                  que coletamos, com nossos parceiros de marketing para permitir que eles lhe forneçam conteúdo mais
                  personalizado e estudem a eficácia de campanhas de publicidade.
                  <br />
                  <br />
                  ● Conforme acreditarmos ser necessário ou apropriado: (a) nos termos da legislação aplicável,
                  incluindo leis de países que não a de seu país de residência; (b) para cumprir com processos legais;
                  (c) para responder a solicitações de autoridades públicas e governamentais, incluindo autoridades
                  públicas e governamentais de países que não a de seu país de residência; (d) para aplicar nossos
                  termos e condições; (e) para proteger nossas operações ou aquelas de qualquer de nossas afiliadas; (f)
                  para proteger nossos direitos, privacidade, segurança ou propriedade e/ou os de nossas afiliadas, seus
                  ou de terceiros; e (g) para nos permitir a perseguir recursos disponíveis ou limitar os danos que
                  possamos suportar.
                  <br />
                  <br />● Seus dados pessoais serão processados pela EVOLUCIONAL para lhe fornecer os produtos e
                  serviços solicitados por você e para atividades de serviço de atendimento ao cliente, atividades de
                  marketing e comerciais. Nenhum parceiro comercial receberá suas Informações Pessoais para seus
                  próprios fins publicitários. A EVOLUCIONAL processa seus dados pessoais em conformidade com a
                  legislação de privacidade e proteção de dados aplicável. Caso você tenha quaisquer perguntas sobre o
                  processamento de seus dados pessoais pela EVOLUCIONAL, ou deseje obter uma cópia das informações sobre
                  você detidas pela EVOLUCIONAL, ou solicitar que dados pessoais incorretos sejam retificados ou
                  apagados, por favor, entre em contato conosco.
                </p>
                <br />

                <p style={{ fontWeight: 400 }}>
                  <span style={{ fontWeight: 600 }}>2. Cookies</span>
                  <br />
                  <br />
                  <span style={{ fontWeight: 600 }}>O que são Cookies?</span>
                  Cookies são pequenos arquivos de texto ou fragmentos de informação que são baixados em seu computador,
                  smartphone ou qualquer outro dispositivo com acesso à internet quando você visita nossa aplicação.
                  <br />
                  <br />
                  Eles contêm informações sobre a sua navegação em nossas páginas e retêm apenas informações
                  relacionadas às suas preferências. <br />
                  <br />
                  Assim, essa página consegue armazenar e recuperar os dados sobre os seus hábitos de navegação como,
                  por exemplo, melhorar a sua experiência de uso. É importante frisar que eles não contêm informações
                  pessoais específicas, como dados sensíveis ou bancários.
                  <br />
                  <br />
                  O seu navegador armazena os cookies no disco rígido, mas ocupam um espaço de memória mínimo, que não
                  afetam o desempenho do seu computador. A maioria das informações são apagadas logo ao encerrar a
                  sessão.
                  <br />
                  <br />
                  <span style={{ fontWeight: 600 }}>Por que usamos Cookies?</span>
                  <br />
                  <br />
                  A Evolucional utiliza Cookies para fornecer a melhor experiência de uso, tornando nossas aplicações
                  mais fáceis e personalizadas, tendo por base suas escolhas e comportamento de navegação.
                  <br />
                  <br />
                  Assim, buscamos entender como você utiliza nossas aplicações e ajustar o conteúdo para torná-lo mais
                  relevante para você, além de lembrar de suas preferências.
                  <br />
                  <br />
                  Os Cookies participam deste processo porquanto armazenam, leem e executam os dados necessários para
                  cumprir com o nosso objetivo.
                  <br />
                  <br />
                  Respeitamos o direito à privacidade e você poderá, a qualquer momento, optar pela desativação dos
                  cookies. Essa ação, contudo, pode afetar a disponibilidade de algumas ferramentas e funcionalidades do
                  site ou de nossos serviços, comprometendo seu correto e esperado funcionamento e, eventualmente,
                  comprometendo uma experiência mais personalizada.
                  <br />
                  <br />
                  Importante esclarecer que não nos responsabilizamos pelo uso de cookies por terceiros. Os cookies
                  colocados por terceiros podem, eventualmente, continuar a monitorar as suas atividades online, mesmo
                  depois de ter saído do nosso site, sendo recomendável que você limpe seus dados de navegação
                  regularmente. Os cookies, quanto a sua finalidade, podem ser:
                  <br />
                  <br />
                  <span style={{ fontWeight: 600 }}>● Cookies necessários: </span>são cookies essenciais que
                  possibilitam a navegação em nossas aplicações e o acesso a todos os recursos; sem estes, nossos
                  serviços podem apresentar mal desempenho ou não funcionar.
                  <br />
                  <br />
                  <span style={{ fontWeight: 600 }}>● Cookies de desempenho:</span> são cookies que otimizam a forma que
                  nossas aplicações funcionam, coletando informações anônimas sobre as páginas acessadas.
                  <br />
                  <br />
                  <span style={{ fontWeight: 600 }}>● Cookies de funcionalidade:</span> são cookies que memorizam suas
                  preferências e escolhas (como seu nome de usuário).
                  <br />
                  <br />
                  <span style={{ fontWeight: 600 }}>● Cookies de publicidade:</span>são cookies que direcionam anúncios
                  em função dos seus interesses e limitam a quantidade de vezes que o anúncio aparece.
                  <br />
                  <br />
                  <span style={{ fontWeight: 600 }}>Gerenciamento dos Cookies</span>
                  <br />
                  <br />
                  A instalação dos cookies está sujeita ao seu consentimento. Apesar da maioria dos navegadores estar
                  inicialmente configurada para aceitar cookies de forma automática, você pode rever suas permissões a
                  qualquer tempo, de forma a bloqueá-los, aceitá-los ou ativar notificações para quando alguns cookies
                  forem enviados ao seu dispositivo. <br />
                  <br />
                  Atualmente, na primeira vez que você acessar nossas aplicações, será requerida a sua concordância com
                  a instalação destes. Apenas após a sua aceitação eles serão ativados.
                  <br />
                  <br />
                  Como já dito, você pode, a qualquer tempo e sem nenhum custo, alterar as permissões, bloquear ou
                  recusar os Cookies. Você também pode configurá-los caso a caso. Todavia, a revogação do consentimento
                  de determinados Cookies pode inviabilizar o funcionamento correto de alguns recursos da plataforma.
                  <br />
                  <br />
                  Para gerenciar os cookies do seu navegador, basta fazê-lo diretamente nas configurações do navegador,
                  na área de gestão de Cookies.
                  <br />                 
                </p>
                <br />

                <p style={{ fontWeight: 400 }}>
                  <span style={{ fontWeight: 600 }}>4. Segurança</span>
                  <br />
                  <br />
                  Nós empregamos medidas organizacionais, técnicas e administrativas adequadas para proteger as
                  Informações Pessoais sob nosso controle. Infelizmente, nenhuma transmissão de dados pela Internet ou
                  sistema de armazenamento de dados pode ser garantida como sendo 100% segura.
                  <br />
                  <br />
                  Se você tiver motivos para acreditar que a sua interação conosco tenha deixado de ser segura (por
                  exemplo, se você acreditar que a segurança de qualquer conta que você possa ter conosco tenha sido
                  comprometida), por favor, nos notifique do problema imediatamente, entrando em contato conosco.
                </p>
                <br />

                <p style={{ fontWeight: 400 }}>
                  <span style={{ fontWeight: 600 }}>5. Acesso, Modificação e Escolhas</span>
                  <br />
                  <br />
                  Nós lhe damos várias opções em relação ao nosso uso e divulgação de suas Informações Pessoais para
                  fins publicitários.
                  <br />
                  <br />
                  ● Caso, a qualquer momento, você deseje parar de receber comunicações de marketing enviadas por nós, a
                  forma mais fácil de fazê-lo seria a utilização da função de cancelamento de inscrição na comunicação
                  de marketing que você recebeu. Você também pode entrar em contato conosco, indicando que você deseja
                  parar de receber nossas comunicações.
                  <br />
                  <br />
                  ● Adicionalmente, nós não divulgaremos suas Informações Pessoais a terceiros, para finalidades de
                  marketing direto.
                  <br />
                  <br />
                  ● Note, por favor, que alterações podem não ter efeito imediato. Faremos o possível para cumprir com a
                  sua solicitação assim que razoavelmente praticável e em nenhuma hipótese mais de 30 dias após receber
                  sua solicitação. Por favor, note que se você solicitar não receber de nós mensagens relacionadas a
                  marketing, nós ainda poderemos lhe enviar mensagens administrativas importantes, e você não pode optar
                  por deixar de receber mensagens administrativas.
                  <br />
                  <br />
                  ● Para revisar, corrigir, atualizar, suprimir, apagar ou de outra forma limitar nossa utilização de
                  suas Informações Pessoais que nos tenham sido anteriormente fornecidas, por favor, entre em contato
                  conosco e descreva a sua solicitação de forma clara. Na sua solicitação, por favor, esclareça quais
                  informações você gostaria que fossem alteradas, se você gostaria que suas Informações Pessoais fossem
                  suprimidas de nosso banco de dados ou nos informe de quais limitações você gostaria que aplicássemos
                  ao uso de suas Informações Pessoais.
                  <br />
                  <br />● Nós tentaremos atender à sua solicitação assim que razoavelmente praticável. Note que poderá
                  haver informações residuais que permanecerão em nossos bancos de dados e outros registros, as quais
                  não serão removidas ou modificadas, conforme solicitado pela legislação aplicável. Além disso, por
                  favor, note que nós poderemos ter de manter determinadas informações para fins de manutenção de
                  registros e/ou para concluir quaisquer transações a que você tenha iniciado antes de solicitar tal
                  mudança ou exclusão (por exemplo, quando você realiza uma compra ou participa de uma promoção, você
                  pode não conseguir modificar ou apagar as Informações Pessoais fornecidas até a conclusão de tal
                  compra ou promoção).
                </p>
                <br />

                <p style={{ fontWeight: 400 }}>
                  <span style={{ fontWeight: 600 }}>6. Período De Retenção</span>
                  <br />
                  <br />
                  Nós manteremos suas Informações Pessoais durante o período necessário para cumprir com os propósitos
                  delineados nesta Política de Privacidade.
                </p>
                <br />

                <p style={{ fontWeight: 400 }}>
                  <span style={{ fontWeight: 600 }}>7. Utilização Dos Sites Por Menores De Idade</span>
                  <br />
                  <br />
                  Caso você tenha mais de 16 anos, mas menos de 18 anos, você deve rever os termos dessa Política de
                  Privacidade com um de seus pais ou seu responsável para garantir que ambos compreenderam os termos.
                  Apesar de não sermos responsáveis por determinar a idade de nossos usuários, podemos realizar
                  verificações. Caso descubramos que coletamos informações de um indivíduo com menos de 16 anos,
                  apagaremos essas informações assim que possível e poderemos desativar o acesso desse indivíduo ao
                  website aplicável.
                  <br />
                  <br />
                  Nós oferecemos serviços de consulta que podem ser acessados por menores de idade. Para a proteção da
                  privacidade dos menores, nós exigimos o consentimento dos pais dos usuários que desejarem fazer a
                  consulta do serviço oferecido.
                </p>
                <br />

                <p style={{ fontWeight: 400 }}>
                  <span style={{ fontWeight: 600 }}>8. Informações Sensíveis</span>
                  <br />
                  <br />
                  Nós geralmente solicitamos que você não nos envie, e que você não divulgue, quaisquer Informações
                  Pessoais sensíveis (por exemplo, informações relacionadas à origem étnica ou racial, opiniões
                  políticas, religião ou crenças de outra espécie, condição médica ou de saúde, antecedentes criminais
                  ou participação em sindicato) por meio dos Sites, redes sociais ou de qualquer outra forma.
                </p>
                <br />

                <p style={{ fontWeight: 400 }}>
                  <span style={{ fontWeight: 600 }}>9. Atualizações desta Política de Privacidade</span>
                  <br />
                  <br />
                  Para a Evolucional, a privacidade e confiança são fundamentais para a nossa relação com você. Estamos
                  sempre nos atualizando para manter os mais altos padrões de segurança. <br />
                  <br />
                  Assim, reservamo-nos o direito de alterar esta Política de Privacidade a qualquer tempo e as mudanças
                  entrarão em vigor logo após a publicação.
                  <br />
                  <br />
                  Ao continuar a navegação nas nossas aplicações após essa mudança se tornar eficaz, você concorda com
                  elas. Aconselhamos que você sempre verifique esta Política de Privacidade.
                  <br />
                  <br />
                  Esta Política de Privacidade foi atualizada em: 26/03/2021.
                </p>
                <br />

                <p style={{ fontWeight: 400 }}>
                  <span style={{ fontWeight: 600 }}>10. Contate-nos</span>
                  <br />
                  <br />
                  Se você tiver quaisquer dúvidas sobre esta Política de Privacidade, por favor, nos contate pelo e-mailcontato@evolucional.com.br
                </p>
              </div>
            </Col>
          </Row>
        </Container>
      </div>
    </>
  )
}

export default Politicas
